export const general = [
  {
    title: "How many sellers do you have in your database?",
    content: "We track about 5 million sellers across all Amazon domains. We update new sellers regularly as long as they have active listings and receive customer feedback"
  },
  {
    title: "How often is your data refreshed?",
    content: "Data is refreshed at least once a week for active sellers. You can use the refresh button on the seller dashboard page to get the most up-to-date info on a seller"
  },
  {
    title: "What marketplaces do you support?",
    content: "We currently support the majority of Amazon marketplaces. In North America, we support US, Canada, Mexico, and Brazil. In Europe, we support UK, France, Germany, Spain, and Italy. In Asia, we support Japan and India"
  }
]

export const getStarted = [
  {
    title: "We provide services to Amazon Sellers. How do we use TrackSellers.com to grow our business?",
    content: "eCommerce service providers can find qualified leads that match their criteria using Advanced Seller Search. Seller Dashboard and Seller Intelligence Report can help identify a seller’s business trends and to customize your pitch accordingly"
  },
  {
    title: "How do I use TrackSellers.com to prepare for a sales conversation with a prospective customer?",
    content: "Preparation is key to having a successful sales conversation. We provide you with a business overview and metrics of your customer's Amazon business to ensure that you are well-prepared for the meeting. This can help you pitch how your product or service can help solve your prospect's business challenges"
  },
  {
    title: "I am a supplier or a distributor to Amazon sellers. How do I use TrackSellers.com to monitor my customers?",
    content: "Seller dashboard can help you monitor your customer's business metrics and sales trends. Understanding your customer's business health is essential to growing their accounts"
  }
]

export const features = [
  {
    title: "How do the download credits work?",
    content: "Pro subscription allows downloading detailed information about 200 sellers, which would be enough to fully download top sellers lists in 2 categories. Go to the Top Sellers by Category page, select the category, and click Download. Enterprise subscription allows downloading detailed information about 400 sellers via the Top Sellers by Category page or Advanced Seller Search"
  },
  {
    title: "How do I make a custom list of Amazon seller leads according to my criteria?",
    content: "Sign up for an Enterprise subscription and use Advanced Seller Search. Filter through domain, category, location, reviews, sales, and various criteria to locate the right leads for your business"
  },
  {
    title: "How do I order a Seller intelligence report?",
    content: 'Click on the "Seller Intelligence Report" link on the Seller Dashboard page. Pro and Enterprise subscriptions include credits for one and five reports, respectively. Free and Starter subscribers will be taken to a Stripe checkout page for payment'
  }
]

export const sellerData = [
  {
    title: "Why is there a data mismatch between tracksellers.com and amazon.com?",
    content: "Although unlikely, this could happen because of data refresh timing and issues with Amazon data availability. We recommend clicking the refresh button on the seller dashboard page to get the most up-to-date data"
  },
  {
    title: "How do you rank sellers?",
    content: "Our ranking is primarily based on the volume of feedback the seller receives and their estimated annual sales. We also rank sellers based on their lifetime reviews and 30-day reviews"
  },
  {
    title: "Do you have the contact information of Amazon Sellers?",
    content: "Enterprise and Pro subscription tiers allow downloading seller data, including the business entity and the seller's physical address. Email and phone contact information are available at an additional cost"
  }
]

export const subscriptions = [
  {
    title: "Is there a free trial?",
    content:  "There is a 7 day free trial with STARTER and PRO tier subscriptions"
  },
  {
    title: "Do I need to give access to my Amazon account?",
    content: "No"
  },
  {
    title: "Do the plans support all marketplaces?",
    content: "Our plans allow access to all the marketplaces we support. In the Americas, we support USA, Canada, Mexico, and Brazil. In Europe, we support UK, France, Germany, Spain, and Italy. In Asia, we support Japan and India"
  },
  {
    title: "Can I cancel at any time?",
    content: "Yes, you can cancel anytime and your subscription will continue until the end of the current billing period"
  },
  {
    title: "Can I upgrade at any time?",
    content: 'Yes, you can upgrade anytime by clicking on the user profile icon and selecting "Manage Subscription"'
  },
  {
    title: "What forms of payment do you accept?",
    content: "We use Stripe for secure and easy billing. Stripe accepts all major credit cards"
  }
]
